import type { SVGProps } from "react";

export default function TrophyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="Layer_2"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 23.58 27.03"
      fill="currentColor"
      {...props}
    >
      <g id="Layer_1-2" data-name="Layer 1-2">
        <path d="M21.77,6.5c0,1.16-.94,2.1-2.09,2.1h-.94c.01-.14.04-.28.04-.42V3.83h3v2.67h-.01ZM15.57,9.35c-.32.59-.81,1.09-1.39,1.41-4.19,2.27-8.43-1.97-6.17-6.19.32-.59.81-1.09,1.4-1.4,4.19-2.27,8.42,1.98,6.17,6.19h0ZM3.9,8.59c-1.15,0-2.09-.94-2.09-2.1v-2.67h3v4.35c0,.14.02.28.04.41h-.95ZM22.88,2.01h-4.11V0H4.81v2.01H.7c-.38,0-.7.31-.7.71v3.78c0,2.16,1.75,3.92,3.9,3.92h1.41c.55,1.26,1.49,2.42,2.53,3.26l.3.25c.93.76,1.47,1.89,1.47,3.09v1.62h4.35v-1.86c0-1.06.47-2.05,1.29-2.72l.49-.39c1.03-.84,1.97-2,2.53-3.26h1.41c2.16,0,3.9-1.76,3.9-3.92v-3.77c0-.39-.31-.71-.7-.71h0ZM14.16,6.04l-1.37-.2-.62-1.25c-.21-.43-.56-.43-.77,0l-.62,1.25-1.37.2c-.47.07-.58.4-.24.74l.99.97-.23,1.37c-.08.47.2.68.62.45l1.23-.65,1.23.65c.42.23.7.02.62-.45l-.23-1.37.99-.97c.34-.33.24-.66-.24-.74h0ZM15.01,24.11h-6.45v-1.46h6.45v1.46ZM17.6,22.49c0-1.12-.91-2.03-2.02-2.03h-7.58c-1.12,0-2.02.91-2.02,2.03v2.35h-1.45v2.19h14.51v-2.19h-1.45v-2.35h.01Z" />
      </g>
    </svg>
  );
}
